import { useLocation } from "react-router-dom";

const ViewVendor = ({
  setEditVendorData,
  data,
}) => {
  const location = useLocation();
  return (
    <>
      <div className="d-flex align-items-center flex-column w-100">
        <div class="d-flex align-items-center justify-content-between mt-2 gap-3 w-100 p-2">
          <h2 className="heading text-decoration-none">
            <span> Vendor Details</span>
          </h2>

          {location?.pathname?.includes("Tools") && (
            <button
              className="btn btn-sm btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#editVendorBankDetails"
              onClick={() => setEditVendorData(data)}
            >
              Edit Vendor Bank Details
            </button>
          )}

        </div>
        <div className="w-75 text-black">
          <div className="d-flex px-5 border justify-content-between">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Vendor ID</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.vendorId === "" || data?.vendorId === null ? "N/A" : data?.vendorId}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Full Name</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.fullName === "" || data?.fullName === null ? "N/A" : data?.fullName}
              </span>
            </div>
          </div>

          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>e-Mail ID</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.email === "" || data?.email === null ? "N/A" : data?.email}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Mobile</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.mobile === "" || data?.mobile === null ? "N/A" : data?.mobile}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Aadhaar Card</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.aadhaarNo === "" || data?.aadhaarNo === null ? "N/A" : data?.aadhaarNo}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>PAN Number</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.panNumber === "" || data?.panNumber === null ? "N/A" : data?.panNumber}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Bank Name</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.bankName === "" || data?.bankName === null ? "N/A" : data?.bankName}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Account Number</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.accountNumber === "" || data?.accountNumber === null ? "N/A" : data?.accountNumber}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>IFSC Code</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.ifscCode === "" || data?.ifscCode === null ? "N/A" : data?.ifscCode}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Branch Name</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.branchName === "" || data?.branchName === null ? "N/A" : data?.branchName}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>UPI</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">{data?.upi === "" || data?.upi === null ? "N/A" : data?.upi}</span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Approval</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span
                className={`mx-5 ${data?.vendorStatus === "Approved"
                  ? "text-success"
                  : data?.vendorStatus === "Rejected"
                    ? "text-danger"
                    : "text-primary"
                  }`}
              >
                {" "}
                <b>{data?.vendorStatus === "" || data?.vendorStatus === null ? "N/A" : data?.vendorStatus}</b>{" "}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Approve/Reject Date</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {" "}
                {data?.updateDate === "" || data?.updateDate === null
                  ? "N/A"
                  : new Date(data?.updateDate).getDate() +
                  "/" +
                  (new Date(data?.updateDate).getMonth() + 1) +
                  "/" +
                  new Date(data?.updateDate).getFullYear()}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Approve/Reject Time</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {" "}
                {data?.updateDate === "" || data?.updateDate === null
                  ? "N/A"
                  : new Date(data?.updateDate).getHours() +
                  ":" +
                  new Date(data?.updateDate).getMinutes() +
                  ":" +
                  new Date(data?.updateDate).getSeconds()}
              </span>
            </div>
          </div>
          <div className="d-flex px-5 border justify-content-between ">
            <div className="border-end  w-50 p-2">
              <b>
                <span>Rejection Remark</span>
              </b>
            </div>
            <div className=" w-50 p-2">
              <span className="mx-5">
                {data?.remark === "" || data?.remark === null ? "N/A" : data?.remark}
              </span>
            </div>
          </div>

          {/* <div className="d-flex justify-content-end mt-3">
          <div className="Advanced-btn">
            <button
              className={`btn btn-sm btn-danger`}
              data-bs-toggle="modal"
              data-bs-target="#ViewVendor"
            >
              &#x2190; Close
            </button>
          </div>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default ViewVendor;
